var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-collapse", attrs: { shadow: "hover" } },
        [
          _c("app-header-dados-processo", {
            attrs: {
              processo: _vm.processo,
              isCCR: _vm.isCCR,
              dadosCadastros: _vm.dadosCadastros
            }
          })
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            [
              _c(
                "el-steps",
                {
                  staticClass: "card-container",
                  attrs: {
                    active: _vm.active,
                    "finish-status": "success",
                    simple: "simple"
                  }
                },
                [
                  _c("el-step", { attrs: { title: "Informar dados do VTN" } }),
                  _c("el-step", { attrs: { title: "Confirmar dados VTN" } })
                ],
                1
              ),
              _vm.active === 0
                ? _c(
                    "validation-observer",
                    { ref: "validation", attrs: { tag: "div" } },
                    [
                      _vm.active === 0
                        ? _c(
                            "div",
                            [
                              _c("InformarDados", {
                                attrs: { vtnRequest: _vm.vtnRequest },
                                on: { setDados: _vm.setDados }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm.active === 1
                ? _c(
                    "div",
                    [
                      _c("ConfirmarDados", {
                        attrs: { dadosVtn: _vm.dadosVtn, processo: _vm.proc }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              true
                ? _c(
                    "el-card",
                    {
                      staticClass: "card-collapse",
                      attrs: { shadow: "hover" }
                    },
                    [
                      _c(
                        "validation-observer",
                        { ref: "validation", attrs: { tag: "div" } },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "flex-despacho" },
                                        [
                                          _c("p", { staticClass: "label" }, [
                                            _vm._v("Despacho"),
                                            _c(
                                              "span",
                                              { staticClass: "required" },
                                              [_vm._v("  *  ")]
                                            )
                                          ]),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: {
                                                click: _vm.openModalDespacho
                                              }
                                            },
                                            [
                                              _vm._v("Modelo  "),
                                              _c("div", {
                                                staticClass: "fa fa-file"
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c("app-editor-texto", {
                                        ref: "editorTexto",
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        on: { onTextChange: _vm.onTextChange },
                                        model: {
                                          value: _vm.despacho.textoDespacho,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.despacho,
                                              "textoDespacho",
                                              $$v
                                            )
                                          },
                                          expression: "despacho.textoDespacho"
                                        }
                                      }),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              642439113
                            )
                          })
                        ],
                        1
                      ),
                      _c("app-anexo", {
                        attrs: {
                          id: "upload-anexo-despacho",
                          files: _vm.anexos,
                          tipoExibir: "ANEXO_ANALISE"
                        },
                        on: {
                          uploadFile: _vm.uploadFile,
                          removeFile: _vm.removeFile,
                          downloadDocumentoCadastro:
                            _vm.downloadDocumentoCadastro
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "validation-observer",
                {
                  ref: "validaAcaoSelecionada",
                  staticClass: "flex-around",
                  attrs: { tag: "div" }
                },
                [
                  _vm.tarefa && _vm.tarefa.acoes && _vm.active === 1
                    ? _c("app-radios-tramitacao", {
                        attrs: {
                          radios: _vm.tarefa.acoes,
                          isDecisao: true,
                          isEsconderEncaminhamento: true,
                          radioInicial: _vm.acao
                        },
                        on: { changeRadio: _vm.changeRadio }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c("app-buttons-cadastro", {
                attrs: {
                  showButtonCancelar: true,
                  showButtonProximo: true,
                  showButtonSalvar: true,
                  isUltimoPasso: _vm.isUltimoPasso,
                  isPrimeiroPasso: _vm.isPrimeiroPasso
                },
                on: {
                  proximo: _vm.proximo,
                  voltar: _vm.voltar,
                  cancelar: _vm.cancelar,
                  finalizar: _vm.finalizar,
                  salvar: _vm.salvar
                }
              })
            ],
            1
          )
        ]
      ),
      _vm.showModalDespacho
        ? _c("app-modal-selecionar-modelo-notificacao", {
            attrs: {
              tiposModelo: _vm.tiposModelo,
              titulo: _vm.tituloModalModelo,
              idProcesso: _vm.processo.id,
              showModal: _vm.showModalDespacho
            },
            on: {
              closeModal: _vm.fecharModalDespacho,
              setTextoDespacho: _vm.setTextoDespacho
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-511dd815", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-511dd815","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/cadastrarVtn.vue
// module id = null
// module chunks = 